import { useSelector } from 'react-redux';
import { RootState } from '../store/store';
import userNotificationService from '../services/notification/userNotification.service';
import { createPollingStore } from '../utils/createPollingStore';

/** Header rozeti ve Bildirimlerim sayfası arasında paylaşılan okunmamış bildirim sayacı */
export const userNotificationUnreadStore = createPollingStore<number>(
  () => userNotificationService.getUnreadCount().then((res) => res?.count ?? 0),
  0,
  60000
);

export const useUserNotificationUnreadCount = (): number => {
  const user = useSelector((state: RootState) => state.auth.user);
  return userNotificationUnreadStore.useValue(!!user);
};
